import {SpriteButtonView} from '../../ui_canvas_engine/SpriteButtonView'
import {FloatingText} from '../../game_ui_view_objects/FloatingText'
import {GameStateEnums, ModeSettingEnum} from '../../../../../shared/GameEnums'
import {UIGameManager} from '../UIGameManager'
import {UIGameMechanic} from '../UIGameEventController'
import {UIGamePlayerInformationSpecialBuildPhaseFlagController} from './UIGamePlayerInformationSpecialBuildPhaseFlagController'
import {UIUtilsEjsVariables} from '../../UIUtilsEjsVariables'
import {Sprites} from '../UIGameImageDictionary'
import {UIGameSpriteHandler} from '../../UIGameSpriteHandler'
import UIGameEventEnums = GameStateEnums.UIGameEventEnums
import {MechanicSpecialBuildPhasePlayerState, MechanicSpecialBuildPhaseState, TurnState} from '@colonist/game-states'

export class UIGameSpecialBuildPhaseButtonController implements UIGameMechanic {
    protected readonly uiGameManager: UIGameManager
    private readonly mySpecialBuildPhaseState: MechanicSpecialBuildPhasePlayerState
    button?: SpriteButtonView

    constructor(uiGameManager: UIGameManager, specialBuildPhaseState: MechanicSpecialBuildPhaseState) {
        if(uiGameManager.gameController.isReplay) return
        this.uiGameManager = uiGameManager

        const mySpecialBuildPhaseState = specialBuildPhaseState.playerStates[this.uiGameManager.gameController.myColor]
        if(mySpecialBuildPhaseState == undefined) return
        this.mySpecialBuildPhaseState = mySpecialBuildPhaseState

        this.uiGameManager.eventController.registerUIGameMechanic(this)

        if(this.uiGameManager.gameController.isReplay) return

        this.createButton()

        this.showView()

        this.repositionButtonForGameMode()

        this.inititiatePlayerInformationSpecialBuildPhaseFlagViews()
    }

    private isRequestingSpecialBuildPhase(): boolean {
        if(this.mySpecialBuildPhaseState.isRequesting == true) return true
        return false
    }

    protected createButton() {
        if(this.button === undefined) return

        const texture = UIGameSpriteHandler.getTextureFromSpritesheet(Sprites.icon_special_build_phase_flag)
        this.button.addCenteredIcon(texture)
        this.button.updateAction(() => {
            this.clickedSpecialBuildPhaseButton()
        })
        this.button.setTip({key: 'strings:game.tooltips.requestSpecialBuildPhase'}, [{key: 'strings:colonistCommon.utils.emptyString'}])
    }

    onEvent(data: any, eventType: UIGameEventEnums) {
        switch(eventType) {
            case UIGameEventEnums.SpecialBuildPhaseStateUpdated: this.specialBuildPhaseStateUpdated(); break
            case UIGameEventEnums.PlayerControllerStateUpdated:
            case UIGameEventEnums.GameStateUpdated: this.updateOpacity(); break
            case UIGameEventEnums.CanvasResized: this.onCanvasResize(); break
            default: break
        }
    }

    private onCanvasResize() {
        this.button?.destroy()
        this.createButton()
        this.repositionButtonForGameMode()
    }

    // Jan 2, 2020. Jeff. This structure is temporary until the new button controller is designed
    private repositionButtonForGameMode() {
        if(this.button === undefined) return
        if(UIUtilsEjsVariables.isUserOnMobileApp && UIUtilsEjsVariables.shouldDisplayNewMobileGameUI) return
        if(!this.isModeWithSpecialBuildPhaseButtonRepositioned()) return

        const canvas = this.uiGameManager.canvasController
        this.button.y -= canvas.itemSize / 2
        this.button.x += canvas.itemSize / 2
    }

    private isModeWithSpecialBuildPhaseButtonRepositioned(): boolean {
        if(this.uiGameManager.gameController.gameSettings.modeSetting == ModeSettingEnum.Seafarers56P) return true
        if(this.uiGameManager.gameController.gameSettings.modeSetting == ModeSettingEnum.CitiesAndKnights56P) return true
        if(this.uiGameManager.gameController.gameSettings.modeSetting == ModeSettingEnum.CitiesAndKnightsSeafarers56P) return true

        return false
    }

    private clickedSpecialBuildPhaseButton() {
        if(!this.canToggleSpecialBuildPhase(true)) return
        this.toggleSpecialBuildPhase()
    }

    private canToggleSpecialBuildPhase(displayText: boolean): boolean {
        if(this.uiGameManager.gameController.isPlayerSpectator) return false
        if(this.button === undefined) return false

        if(this.uiGameManager.gameController.currentState.turnState == TurnState.InitialPlacement) {
            if(displayText) new FloatingText({key: 'strings:game.errors.finishGameSetup'}, this.button)
            return false
        }
        return true
    }

    private toggleSpecialBuildPhase() {
        this.isRequestingSpecialBuildPhase() ? this.uiGameManager.socketGameSend.cancelSpecialBuildPhase() : this.uiGameManager.socketGameSend.requestSpecialBuildPhase()
    }

    private specialBuildPhaseStateUpdated() {
        this.isRequestingSpecialBuildPhase() ? this.button?.highlight() : this.button?.removeHighlight()
    }

    private updateOpacity() {
        this.button?.activateOpacity()

        if(!this.canToggleSpecialBuildPhase(false)) this.button?.inactivateOpacity()
    }

    private showView() {
        if(this.button === undefined) return
        if(this.button.parent != undefined) return
        this.uiGameManager.canvasController.app.stage.addChild(this.button)
    }

    private inititiatePlayerInformationSpecialBuildPhaseFlagViews() {
        for(const playerInformation of this.uiGameManager.playersController.playerInformationViews) {
            new UIGamePlayerInformationSpecialBuildPhaseFlagController(this.uiGameManager, playerInformation)
        }
    }
}
